// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"a51fb714","362":"56b9084d"}[chunkId] + ".chunk.css";
};